


























import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import CImg from '~/components/shared/configurable/image/CImg.vue'

export default defineComponent({
  components: { CImg },
  props: {
    thumbs: { type: Array as PropType<string[]>, required: true },
    lazy: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    width: { type: [Number, String], default: null },
    height: { type: [Number, String], default: null }
  },
  setup(props) {
    const { thumbs, horizontal } = toRefs(props)

    const imagesToShow = computed(() => {
      const noPhotosCount = thumbs.value.reduce((acc, t) => {
        if (t.includes('no_photo')) {
          return acc++
        }
      }, 0)

      if (noPhotosCount) {
        if (noPhotosCount === thumbs.value.length) {
          // just show 1 pic of no_photo if all are no_photo
          return [thumbs.value[0]]
        }
        return [...thumbs.value.filter(t => !t.includes('no_photo'))].splice(
          0,
          4
        )
      }

      return [...thumbs.value].splice(0, 4)
    })

    const widthClass = computed(() => {
      switch (imagesToShow.value.length) {
        case 1:
          return 'tw-w-full'
        case 2: {
          if (horizontal.value) {
            return 'tw-w-full'
          }
          return 'tw-w-[calc(50%_-_0.25rem)]'
        }
        default:
          return 'tw-w-[calc(50%_-_0.25rem)]'
      }
    })
    const heightClalss = computed(() => {
      switch (imagesToShow.value.length) {
        case 1:
          return 'tw-h-full'
        case 2: {
          if (horizontal.value) {
            return 'tw-h-1/2'
          }
          return 'tw-h-full'
        }
        default:
          return 'tw-h-[calc(50%_-_0.25rem)]'
      }
    })

    return {
      imagesToShow,
      widthClass,
      heightClalss
    }
  }
})
